import type InstantMessagePayload from 'owa-service/lib/contract/InstantMessagePayload';
import {
    changeSignInState,
    setIsRetrySignInAllowed,
    setProcessingManualSignIn,
} from '../../actions/presenceActions';
import ChatSignInState from '../../store/schema/ChatSignInState';
import setServiceAvailability from './setServiceAvailability';

export default function onSignedOn(notification: InstantMessagePayload) {
    if (!notification.SignOnStarted) {
        setServiceAvailability(true);
        changeSignInState(ChatSignInState.SignedIn);
        setIsRetrySignInAllowed(true /*isAllowed*/);
        setProcessingManualSignIn(false /*isManualSignIn*/);
    }
}
